import { Injectable } from '@angular/core';
import { StorageService } from './storage.service';

@Injectable({
  providedIn: 'root'
})
export class BancheService {

  constructor(private storage: StorageService) { }

  setBanche(banche: any) {
    return this.storage.set('BANCHE', JSON.stringify(banche));
  }

  getBanche() {
    if (this.storage.get('BANCHE')) {
      return JSON.parse(this.storage.get('BANCHE'));
    }
  }

  removeBanche() {
    return this.storage.remove('BANCHE');
  }
}
